import React, { useEffect, useState } from "react";
import { Slide, Button, Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import * as APIStore from "../store/APIStore";
import { connect } from "react-redux";
import { RouteComponentProps, useParams } from "react-router";
import { ApplicationState } from "../store";
import RequestAccessToken from '../util/authService';
import Typography from "@material-ui/core/Typography";

type PtMedicalRecordProps = {
    MedicalRecord: APIStore.FocusMedicalRecordState,

} & typeof APIStore.actionCreators & RouteComponentProps<{ ptid: string, recordName: string }>;


const PtMedicalRecordDisplay = (props: PtMedicalRecordProps) => {
    let { requestPatientDocument, MedicalRecord } = props;
    let [fetchRequested, setFetchRequested] = useState(false);
    let [medicalRecordEntry, setMedicalRecordEntry] = useState<APIStore.PatientMedicalRecord>()
    let [tokenState, setTokenState] = useState<APIStore.TokenType>();

    let { condensedName, ptid } = useParams();


    useEffect(() => {
        if (MedicalRecord?.isLoaded) {
            if (MedicalRecord.medicalRecord) {
                setMedicalRecordEntry(MedicalRecord.medicalRecord)
            }
        }

    }, [tokenState, MedicalRecord])

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    if (!fetchRequested) {
        if (tokenState) {
            setFetchRequested(true)

            requestPatientDocument(ptid, condensedName, tokenState.accessToken)
        }

    }

    if (medicalRecordEntry) {
        return (
            <div className="maincontent">
                <Paper elevation={1} style={{ padding: 10 }}>
                    <Grid container xs={12} justifyContent="space-between" alignContent="space-between" direction="row" spacing={2}>
                        <Grid item xs={3}>
                            <Typography variant="body1" gutterBottom>
                                <strong>Type:{" "}</strong>
                                <Typography variant="body2" >
                                    {medicalRecordEntry.documentType}
                                </Typography>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" gutterBottom>
                                <strong>Name:{" "}</strong>
                                <Typography variant="body2" >
                                    {medicalRecordEntry.recordName}
                                </Typography>
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="body1" gutterBottom>
                                <strong>Date:{" "}</strong>
                                <Typography variant="body2" >
                                    {medicalRecordEntry.createdDate}
                                </Typography>
                            </Typography>
                        </Grid>

                    </Grid>
                    <Paper style={{ padding: 20 }}  elevation={6}>
                        <Box style={{ 'white-space': "pre" }}>
                            {MedicalRecord.medicalRecord?.content}
                        </Box>
                    </Paper>




                </Paper>
            </div>)

    }

    return (<>
        <p>Loading</p>
    </>)

};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(PtMedicalRecordDisplay as any);
